import styled from "styled-components";

export const TwoFactorAuthenticationContainer = styled.section`
  h2 {
    margin-bottom: 0px !important;
    color: #414651;
    font-size: 14px;
    font-weight: 500;
    font-family: "Geist", sans-serif;
  }

  .divider {
    border-top: 1px solid ${({ theme }) => theme.menu.divider};
  }

  .switch-wrapper {
    display: flex;
    align-items: center;
    gap: 32px;
    margin-bottom: 25px;

    span {
      color: #535862;
      font-size: 14px;
      font-weight: 400;
    }
    .text-message-inner-wrapper p {
      font-size: 14px;
      font-weight: 500;
      font-family: "Geist", sans-serif;
      color: #414651;
    }
    .text-message-wrapper {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    .text-message-wrapper {
      flex: 1;
    }
    .heading-wrapper {
      flex: 1;
    }

    .info-icon {
      margin-left: 6px;
    }

    .secondary {
      label {
        width: 46px;
        height: 26px;
      }

      .slider {
        background-color: ${({ theme }) => theme.switch.bg.primary} !important;

        &:before {
          background-color: ${({ theme }) => theme.switch.bg.secondary};
          height: 20px;
          width: 20px;
          left: 3px;
          top: 3px;
          bottom: 0px;
        }
      }

      input:checked + .slider {
        background-color: ${({ theme }) => theme.button.bg.primary} !important;
      }
      .password-heading-wrapper {
        h2 {
          margin-bottom: 0px !important;
          font-size: 14px;
          font-weight: 500;
          font-family: "Geist", sans-serif;
          color: #414651;
        }
      }

      input:checked + .slider:before {
        -webkit-transform: translateX(20px);
        -ms-transform: translateX(20px);
        transform: translateX(20px);
      }
    }
  }

  @media (max-width: 768px) {
    h2 {
      font-size: 18px;
    }

    .switch-wrapper {
      flex-direction: column;
    }
  }
`;
